import { useState, useEffect, useCallback } from 'react';
import { api, useWorkspace, errorText } from './workspace';

export function useRecords(endpoint: string, pollMs = 0) {
  const { user } = useWorkspace();
  const [records, setRecords] = useState<any[]>([]), [loading, setLoading] = useState(false), [error, setError] = useState('');
  const reload = useCallback(async () => {
    if (!user) { setRecords([]); return; }
    setLoading(true);
    try { const r = await api.get(endpoint); setRecords(r.data); setError(''); } catch (e) { setError(errorText(e)); } finally { setLoading(false); }
  }, [endpoint, user]);
  useEffect(() => { reload(); const listener = () => { reload(); }; window.addEventListener('qe-data-changed', listener); return () => window.removeEventListener('qe-data-changed', listener); }, [reload]);
  useEffect(() => { if (!user || !pollMs) return; const timer = setInterval(reload, pollMs); return () => clearInterval(timer); }, [user, pollMs, reload]);
  return { records, loading, error, reload };
}